<template>
    <div>
        <title>{{$t('company.webtitle')}}</title>
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">       
        <div class="cont">
            <h1>{{ $t('company.firmakontakt_text_1') }}</h1>
            <h3>{{ $t('company.firmakontakt_text_2') }}</h3>
            <div class="first">
                <h3>{{ $t('company.firmakontakt_text_3') }}</h3>
                <nazov-slug 
                    :company="company" 
                    :companies="companies"
                    @data="getData($event, 1)"  />
                <web-tel 
                    :company="company"
                    @data="getData($event, 2)" />
            </div>
            <div class="first mt-4">
                <h3>{{ $t('company.firmakontakt_text_4') }}</h3>
                <logo 
                    :ploadlogo="ploadlogo" 
                    @data="getData($event, 3)"  />
                <signature
                    :ploadsignature="ploadsignature"
                    @data="getData($event, 7)"/>
            </div>
            <div class="first mt-4">
                <h3>{{ $t('company.firmakontakt_text_5') }}</h3>
                <h4>{{ $t('company.firmakontakt_text_6') }}</h4>
                <kontaktna-osoba 
                    :company="company"
                    @data="getData($event, 4)" />
            </div>
            <div class="first mt-4">
                <h3>{{ $t('company.firmakontakt_text_7') }}</h3>
                <h4>{{ $t('company.firmakontakt_text_8') }}</h4>
                <firemne-udaje 
                    :data="user"
                    @data="getData($event, 5)" />
            </div>
            <div class="first mt-4">
                <h3>{{ $t('company.firmakontakt_text_9') }}</h3>
                <h4>{{ $t('company.firmakontakt_text_10') }}</h4>
                <social-media 
                    :company="company"
                    @data="getData($event, 6)"  />
            </div>
            <div v-if="is_admin" class="first mt-4">
                <h3>{{ $t('company.firmakontakt_text_11') }}</h3>
                <h4>{{ $t('company.firmakontakt_text_12') }}</h4>
                <price-templates 
                    :template_value="user.template_type"
                    @data="getData($event, 8)" />
            </div>
            <div class="ulozit" @click="save">
                <span v-show="!saved">{{ $t('company.firmakontakt_text_13') }}</span>
                <div v-show="saved" class=" lds-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WebTel from './components/WebTel.vue'
import NazovSlug from './components/NazovSlug.vue'
import Logo from './components/Logo.vue'
import KontaktnaOsoba from './components/KontaktnaOsoba.vue'
import SocialMedia from './components/SocialMedia.vue'
import FiremneUdaje from './components/FiremneUdaje.vue'
import Signature from './components/Signature.vue'
import PriceTemplates from './components/PriceTemplates.vue'
export default {
    components: { NazovSlug, WebTel, Logo, KontaktnaOsoba, SocialMedia,FiremneUdaje,Signature, PriceTemplates },
    props: ['ploadlogo','data_companies', 'data_user','ploadsignature','is_admin'],
    data() {
        return {
            company:null,
            companies: null,
            error: false,
            saved: false,
            logo: null,
            user: null
        }
    },
    created () {
        this.company = this.data_user.company
        this.companies = this.data_companies
        this.user = this.data_user
    },
    methods: {
        save() {
            if(!this.error){
                this.saved = true
                axios.patch(`/api/settings/firma_a_kontakty`, {company: this.company, user: this.user})
                .then(response => {
                    if(this.logo != null){
                        const fd = new FormData();
                        fd.append('file', this.logo)
                        axios.post(`/api/offer/file`, fd)
                        .then(response => {})
                        .catch(function (error) {});
                    }
                    if(this.signature != null){
                        const fd = new FormData();
                        fd.append('file', this.signature)
                        axios.post(`/api/offer/file/signature`, fd)
                        .then(response => {})
                        .catch(function (error) {});
                    }
                    setTimeout(() => {
                        this.saved = false
                        this.$toast.success(this.$t('company.information_text_1'), {timeout: 2038});
                    }, 500);
           
                })
                .catch(errors => {});
      
            }
        },
        getData(value, id){
            if(id == 1){
                if(!value.error){
                    this.company.firma = value.firma
                    this.company.slug = value.slug
                    this.error = false
                }else{
                    this.error = value.error
                }
            }
            if(id == 2){
                this.company.web = value.web
                this.company.tel = value.tel
                this.company.dph = value.dph
            }
            if(id == 3){
                this.logo = value
            }
            if(id == 4){
                this.company.ko_meno = value.ko_meno
                this.company.ko_email = value.ko_email
                this.company.ko_tel = value.ko_tel
            }
            if(id == 5){
                this.user = value
            }
            if(id == 6){
                this.company.fb = value.fb
                this.company.ig = value.ig
                this.company.yt = value.yt
                this.company.lin  = value.lin
            }
            if(id == 7){
                this.signature = value
            }
            if(id == 8){
                this.user.template_type = value
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.cont{
    width: 1188px;
    margin: 0 auto;
    padding: 35px 0;
    @media only screen and (max-width: 1500px) {
        width: 95%;
    }   
    h1{
        @media only screen and (max-width: 600px) {
            width: 90%;
            margin: 0 auto;
        }
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 28px;
        text-align: center;
        color: #000000;
    }
    h3{
        width: 530px;
        @media only screen and (max-width: 600px) {
            width: 90%;
        }
        margin: 10px auto 27px auto;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 150%;
        text-align: center;
        color: #9598A7;
    }
    .first{
        width: 480px;
        padding: 24px;
        background: #FFFFFF;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        margin: 0 auto;
        h3{
            width: auto;
            margin: 0 0 19px 0;
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 21px;
            color: #212541;
            text-align: left;
        }
        h4{
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 21px;
            color: #9598A7;
            margin-bottom: 18px;
        }
        .form-group{
            display: flex;
            align-items: center;
            margin-bottom: 0px;
        }
        label{
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #212541;
        }
        input[type="checkbox"] {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            -webkit-tap-highlight-color: transparent;
            cursor: pointer;
            margin: 0px 10px 0 0px;
            background: #C7D4EB;
            border-radius: 25px;
        }
        .toggle{
            height: 22px;
            width: 40px;
            display: inline-block;
            position: relative;
            margin: 0;
            border: none;
            background: #FFFFFF;
            border-radius: 3px;
            transition: all 0.2s ease;
            &:focus {
                outline: 0;
            }
            &:after {
                content: "";
                position: absolute;
                top: 4px;
                left: 3px;
                width: 14px;
                height: 14px;
                border-radius: 50%;
                background: white;
                box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
                transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
            }
            &:checked {
                border-color: #2ED8B6;
                background: #2ED8B6;
            }
            &:checked:after {
                transform: translatex(20px);
                
            }
        }
        .info{
            position: relative;
            height: 20px;
            margin-left: 10px;
            .info_icon{
                pointer-events: all;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 20px;
                height: 20px;
                float: right;
                img{
                    width: 80%;
                    height: 80%;
                }
            }
            .my_tooltip{
                bottom: 22px;
                right: -7px;
            }
        }
        .agree_tooltip{
            position: relative;
        }
        .my_tooltip{
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 700;
            pointer-events: none;
            opacity: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 300px;
            background: #F3385A;
            box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
            border-radius: 6px;
            font-weight: 800;
            font-size: 14px;
            line-height: 18px;
            color: #fff;
            padding: 10px;
            position: absolute;
            top: unset;
            right: 15px;
            z-index: 10000;
            transition: opacity .5s ease-in-out;
            &::after{
                content: '';
                width: 15px;
                height: 15px;
                background: #F3385A;
                position: absolute;
                right: 10px;
                bottom: -3px;
                transform: rotate(45deg);
                border-radius: 3px;
            }
        }
    }
    .ulozit{
        width: 480px;
        height: 55px;
        @media only screen and (max-width: 600px) {
            width: 95%;
        }
        margin: 15px auto 0 auto;
        background: #2ED8B6;
        border-radius: 4px;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        color: #FFFFFF;
        cursor: pointer;
        transition: .5s all;
        &:hover{
            background: #23caa9;
        }
    }
}
.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #fff;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
}
@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
}
@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(24px, 0);
    }
}   
</style>